import { AdminHeader, AdminSidebar } from 'components/molecules';
import './AllLeaveApprovals.scss';
import AllLeaveRequests from 'components/molecules/AllLeaveRequests';

const AllLeaveApprovals = () => {
  return (
    <>
      <AdminHeader />
      <div className="dashboard-wrapper">
        <AdminSidebar />
        <AllLeaveRequests />
      </div>
    </>
  );
};

export default AllLeaveApprovals;
